import React, { useMemo } from 'react';
import { Card as AntCard } from 'antd';
import classNames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';
import './RMCard.scss';

/**
 * Base RMCard Component
 *
 * Ant Design Card component with theming
 */
export const RMCard = ({
    children,
    className = '',
    variant = null,
    backgroundFill = false,
    showMoreIcon = true,
    onMoreClick,
    style = {},
    ...props
}) => {
    // Memoize style with CSS variables based on variant
    const cardStyle = useMemo(() => {
        const baseStyle = { ...style };
        if (backgroundFill) {
            if (variant === 'ready') {
                baseStyle['--card-background'] = 'var(--card-background-blue)';
            } else if (variant === 'danger') {
                baseStyle['--card-background'] = 'var(--card-background-red)';
            } else if (variant === 'notReady') {
                baseStyle['--card-background'] = 'var(--card-background-amber)';
            } else {
                baseStyle['--card-background'] = 'var(--card-background-default)';
            }
        }

        if (variant === 'ready') {
            baseStyle['--card-border'] = 'var(--card-border-blue)';
            baseStyle['--card-text'] = 'var(--card-text-blue)';
        } else if (variant === 'danger') {
            baseStyle['--card-border'] = 'var(--card-border-red)';
            baseStyle['--card-text'] = 'var(--card-text-red)';
        } else if (variant === 'notReady') {
            baseStyle['--card-border'] = 'var(--card-border-amber)';
            baseStyle['--card-text'] = 'var(--card-text-amber)';
        } else {
            baseStyle['--card-border'] = 'var(--card-border-default)';
            baseStyle['--card-text'] = 'var(--card-text-default)';
        }

        return baseStyle;
    }, [variant, style]);

    return (
        <AntCard className={classNames('rm-card', className)} style={cardStyle} {...props}>
            <div className="rm-card-container">
                <div className="rm-card-content">{children}</div>
                {showMoreIcon && <MoreOutlined className="rm-card-more-icon" onClick={onMoreClick} />}
            </div>
        </AntCard>
    );
};

export default RMCard;
